import mitt from 'mitt'

export default defineNuxtPlugin({
  name: 'eventBus',
  setup(nuxtApp) {
    const emitter = mitt()
    return {
      provide: {
        listen: emitter.on,
        ignore: emitter.off,
        event: emitter.emit,
      },
    }
  },
})
